import { VideoOff } from 'lucide-react';

/** Coin de visée (cadre 210×210 centré, 4 angles blancs). */
const COIN_STYLES = [
  { top: 0, left: 0, borderRight: 0, borderBottom: 0 },
  { top: 0, right: 0, borderLeft: 0, borderBottom: 0 },
  { bottom: 0, left: 0, borderRight: 0, borderTop: 0 },
  { bottom: 0, right: 0, borderLeft: 0, borderTop: 0 },
];

/**
 * Flux caméra plein écran + canvas de détection superposé (mêmes dimensions
 * intrinsèques et même object-cover → les contours dessinés en coordonnées
 * vidéo restent alignés), coins de visée, flash vert au scan validé.
 */
const ScanViewport = ({ videoRef, canvasRef, cameraActive, cameraError, onRestart, flash, scanning }) => (
  <div className="absolute inset-0">
    <video
      ref={videoRef}
      muted
      playsInline
      className="absolute inset-0 w-full h-full object-cover"
    />
    <canvas
      ref={canvasRef}
      className="absolute inset-0 w-full h-full object-cover"
    />

    {flash > 0 && <div key={flash} className="scan-flash absolute inset-0 pointer-events-none z-[2]" />}

    {cameraError ? (
      <div className="absolute inset-0 z-[3] flex flex-col items-center justify-center gap-4 px-8 text-center">
        <VideoOff size={34} className="text-amber-400" />
        <p className="text-white text-sm font-semibold">{cameraError}</p>
        <button
          type="button"
          onClick={onRestart}
          className="px-5 py-2.5 rounded-xl bg-white text-sm font-bold"
          style={{ color: '#12161c' }}
        >
          Réessayer
        </button>
        <p className="text-xs" style={{ color: 'rgba(255,255,255,.55)' }}>
          La saisie de secours reste disponible en bas de l'écran.
        </p>
      </div>
    ) : !cameraActive ? (
      <div className="absolute inset-0 z-[3] flex items-center justify-center">
        <p className="text-sm" style={{ color: 'rgba(255,255,255,.7)' }}>Démarrage de la caméra…</p>
      </div>
    ) : scanning ? (
      <>
        <div
          className="absolute pointer-events-none"
          style={{ left: '50%', top: '44%', transform: 'translate(-50%,-50%)', width: 210, height: 210, opacity: .5 }}
          aria-hidden="true"
        >
          {COIN_STYLES.map((s, i) => (
            <span key={i} className="absolute w-[26px] h-[26px] border-[3px] border-white rounded-[2px]" style={s} />
          ))}
        </div>
        <p
          className="absolute pointer-events-none text-center text-[12.5px] font-medium"
          style={{ left: '50%', top: '57%', transform: 'translateX(-50%)', width: '80%', color: 'rgba(255,255,255,.7)' }}
        >
          Cadre un groupe, tiens deux secondes, passe au suivant. Un contour qui reste jaune : carte à redresser.
        </p>
      </>
    ) : null}
  </div>
);

export default ScanViewport;
